// @flow
import * as React from 'react';
import { Field } from 'redux-form';

import Input from './Input';

type Props = {
	name: string,
	inputRef?: { current: ?HTMLInputElement } | null,
	className?: string,
	placeholder?: string,
	maxLength?: number,
	onFocus: Function,
	authError?: string,
};

export default class InputField extends React.PureComponent<Props> {
	static defaultProps = {
		inputRef: null,
		className: '',
		placeholder: '',
		maxLength: -1,
		authError: '',
	};

	format = (value: string) => {
		const { maxLength } = this.props;

		if (value) {
			if (maxLength && maxLength > 0 && value.length > maxLength) {
				return value.substr(0, maxLength);
			}
		}

		return value;
	};

	render() {
		const { name, className, placeholder, inputRef, maxLength, onFocus, authError } = this.props;
		const InputComponent = props => (
			<Input
				{...props}
				placeholder={placeholder}
				className={className}
				inputRef={inputRef}
				maxLength={maxLength}
				onFocus={onFocus}
				authError={authError}
			/>
		);

		return <Field name={name} component={InputComponent} format={this.format} />;
	}
}
